// extracted by mini-css-extract-plugin
module.exports = {"lastNodeMessage":"last-node-message_lastNodeMessage__15LXX","dot":"last-node-message_dot__isSJj","panel":"last-node-message_panel__hAvdm"};